export default __webpack_public_path__ + "static/media/KanipakamTempleTwo.47932d46.png";